import { Box, Button, Typography } from "@mui/material";
import React from "react";
import {
    AutocompleteInput,
    Form,
    ReferenceInput,
    required,
    TextInput,
    useCreate,
    useNotify,
    useRefresh,
    useUpdate
} from "react-admin";
import Modal from "components/Modal";
import LoadingButton from "@mui/lab/LoadingButton";
import { validateSpace } from "utils/index";

interface EditSubcategoryModalProps {
    isOpen: boolean;
    onClose: () => void;
    subcategory?: any;
    category?: any;
}

const EditQuestionSubcategoryModal = ({ isOpen, onClose, subcategory, category }: EditSubcategoryModalProps) => {

    const notify = useNotify();
    const refresh = useRefresh();
    const [create, { isPending: isCreating }] = useCreate();
    const [update, { isPending: isUpdating }] = useUpdate();

    const handleSaveEdit = (data: any) => {
        if (subcategory) {
            update(
                `question-subcategory/${subcategory.id}`,
                {
                    id: subcategory.id,
                    data: {
                        ...subcategory,
                        name: data.name,
                        position: data.position,
                        categoryId: data.questionCategory
                    }
                },
                {
                    onSuccess: () => {
                        notify("Подкатегория обновлена", { type: "success" });
                        refresh();
                        onClose();
                    },
                    onError: (error: any) => {
                        notify(error?.message ? error.message : "Ошибка при обновлении подкатегории", { type: "error" });
                    },
                }
            );
        } else {
            create(
                'question-subcategory',
                { data: { name: data.name, position: data.position, categoryId: data.questionCategory } },
                {
                    onSuccess: () => {
                        notify("Подкатегория создана", { type: "success" });
                        refresh();
                        onClose();
                    },
                    onError: (error: any) => {
                        notify(error?.message ? error.message : "Ошибка при создании подкатегории", { type: "error" });
                    },
                }
            )
        }

    };

    const title = subcategory ? 'Редактировать подкатегорию' : "Создать подкатегорию"


    return (
        <Modal open={isOpen} onClose={onClose}>
            <Form
                onSubmit={handleSaveEdit}
                defaultValues={
                    {
                        name: subcategory?.name,
                        questionCategory: subcategory?.categoryId ?? category?.id,
                        position: subcategory?.position
                    }
                }
            >
                <Typography variant="h6" mb={2}>
                    {title}
                </Typography>
                <TextInput
                    fullWidth
                    source={'name'}
                    label="Название подкатегории"
                    size={"small"}
                    validate={[required(), validateSpace]}
                />
                <ReferenceInput
                    reference={'question-category'}
                    source="questionCategory"
                    optionText="title"
                    alwaysOn
                >
                    <AutocompleteInput
                        filterToQuery={(searchText) => ({ category: searchText })}
                        label="Категория"
                        size={'small'}
                        validate={required()}
                    />
                </ReferenceInput>
                <TextInput
                    fullWidth
                    type="number"
                    source={'position'}
                    label="Сортировка / позиция"
                    size={"small"}
                />
                <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={onClose}>Отмена</Button>
                    <LoadingButton
                        loading={isUpdating || isCreating}
                        type={'submit'}
                        variant="contained"
                        color="primary"
                        sx={{ ml: 2 }}>
                        Сохранить
                    </LoadingButton>
                </Box>
            </Form>
        </Modal>
    )
}

export default EditQuestionSubcategoryModal
